import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepWhatHappened = (state) => state.get('stepWhatHappened');

const makeSelectStepWhatHappened = () => createSelector(
  selectStepWhatHappened,
  (stepWhatHappenedState) => ({
    dateOfEvent: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateOfEvent']), ''),
    dateSymptomsStarted: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateSymptomsStarted']), ''),
    timeOfEvent: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'timeOfEvent']), ''),
    country: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'country']), ''),
    city: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'city']), ''),
    province: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'province']), ''),
    selectedCountry: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'selectedCountry']), ''),
    storyEvent: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'storyEvent']), ''),
    // totalAmount: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'totalAmount']), ''),
    title: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'title']), ''),
    firstName: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'firstName']), ''),
    surName: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'surName']), ''),
    dateOfBirth: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateOfBirth']), ''),
    relationshipToYou: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'relationshipToYou']), ''),
    dateYouFirstBecomeAware: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateYouFirstBecomeAware']), ''),
    detailOfMedicalCondition: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'detailOfMedicalCondition']), ''),
    dateBookedTrip: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateBookedTrip']), ''),
    dateScheduledToDepart: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateScheduledToDepart']), ''),
    dateOriginallyScheduled: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateOriginallyScheduled']), ''),
    selectedBenefits: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'selectedBenefits']), ''),
    selectedClaimFor: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'selectedClaimFor']), []),
    whatIsTheOutstandingDuesAmount: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'whatIsTheOutstandingDuesAmount']), []),
    currency: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'currency']), []),
    // Tour Operator
    nameOfTheTourOperator: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'nameOfTheTourOperator']), ''),
    address: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'address']), ''),
    cityOrTown: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'cityOrTown']), ''),
    countryTourOperator: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'countryTourOperator']), ''),
    postalCode: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'postalCode']), ''),
    contact: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'contact']), ''),
    phoneNumber: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'phoneNumber']), ''),
    bookingReservationNumber: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'bookingReservationNumber']), ''),
    destinations: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'destinations']), ''),
    cityOfDeparture: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'cityOfDeparture']), ''),
    returnDestination: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'returnDestination']), ''),
    dateOfInitialPaymentDesposit: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'dateOfInitialPaymentDesposit']), ''),
    ifNotIncludedInThePackage: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'ifNotIncludedInThePackage']), ''),
    // FNOL Claim Split Policies
    usePrimaryMemberEmailAddressForAllMember: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'usePrimaryMemberEmailAddressForAllMember']), ''),
    usePrimaryMemberPhoneNumberForAllMember: mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.getIn(['form', 'usePrimaryMemberPhoneNumberForAllMember']), ''),

    purposeOfTrip: mapWithDefault(
      stepWhatHappenedState,
      () => stepWhatHappenedState.getIn(['form', 'purposeOfTrip']),
      ''
    ),
    whatHappenedValidationFeedback: mapWithDefault(
      stepWhatHappenedState,
      () => stepWhatHappenedState.getIn(['form', 'whatHappenedValidationFeedback']),
      null
    ),
    whatHappenedValidationIsSufficient: mapWithDefault(
      stepWhatHappenedState,
      () => stepWhatHappenedState.getIn(['form', 'whatHappenedValidationIsSufficient']),
      null
    ),
  })
);

const makeSelectCountryList = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => stepWhatHappenedState.get('countryList'));

const makeSelectCountriesOfxSupported = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => stepWhatHappenedState.get('countriesOfxSupported'));

const makeSelectCityList = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => stepWhatHappenedState.get('cityList'));

const makeSelectProvinceList = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => stepWhatHappenedState.get('provinceList'));

const makeSelectClaimTypeList = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) =>
    mapWithDefault(stepWhatHappenedState, () => stepWhatHappenedState.get('claimTypeList'), []),
  );

const makeSelectOldEventDate = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => ({
    oldEventDate: stepWhatHappenedState.get('oldEventDate'),
    oldEventTime: stepWhatHappenedState.get('oldEventTime'),
  }));

const makeSelectPolicyVersionChanged = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => stepWhatHappenedState.get('policyVersionChanged'));

const makeSelectWhatHappenedValidation = () =>
  createSelector(selectStepWhatHappened, (stepWhatHappenedState) => {
    const validation = stepWhatHappenedState.get('whatHappenedValidation');
    return {
      isLoading: validation ? validation.get('isLoading') : false,
      isSufficient: validation ? validation.get('isSufficient') : null,
      feedbackMessage: validation ? validation.get('feedbackMessage') : null,
    };
  });

export {
  makeSelectStepWhatHappened,
  makeSelectCountryList,
  makeSelectCityList,
  makeSelectProvinceList,
  makeSelectClaimTypeList,
  makeSelectOldEventDate,
  makeSelectPolicyVersionChanged,
  makeSelectCountriesOfxSupported,
  makeSelectWhatHappenedValidation,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/selectors.js